module.exports = __webpack_public_path__ + "static/media/wechat_full.45e5670e953f3bb861a1d4cc8f66a88f.svg";